var map = {
	"./24a94e1e.webp": 31526,
	"./5b3e7a36.webp": 22069,
	"./7ece7b5a.webp": 20268,
	"./93f38fd3.webp": 97855,
	"./98fcbb08.webp": 39885,
	"./a1a2bc77.webp": 78651,
	"./abstract-1.webp": 59635,
	"./abstract-10.webp": 4069,
	"./abstract-2.webp": 28914,
	"./abstract-3.webp": 31677,
	"./abstract-4.webp": 10604,
	"./abstract-5.webp": 67695,
	"./abstract-6.webp": 35246,
	"./abstract-7.webp": 4969,
	"./abstract-8.webp": 7416,
	"./abstract-9.webp": 50235,
	"./alice.webp": 60101,
	"./anime.webp": 58781,
	"./aurora-2.webp": 56004,
	"./aurora.webp": 34687,
	"./autumn.webp": 20349,
	"./aviator.webp": 55127,
	"./b909ea37.webp": 23569,
	"./baroque.webp": 20054,
	"./bart.webp": 42044,
	"./beauty.webp": 9119,
	"./bubbles.webp": 78822,
	"./calmness.webp": 81263,
	"./candy.webp": 71316,
	"./canvas.webp": 38475,
	"./capri.webp": 64156,
	"./caribbean.webp": 44678,
	"./carnival.webp": 25585,
	"./ceremony.webp": 78811,
	"./charles.webp": 99009,
	"./coffee.webp": 61371,
	"./colorful.webp": 51045,
	"./comic.webp": 24284,
	"./cordeville.webp": 72854,
	"./crinkle.webp": 45753,
	"./cubism.webp": 9450,
	"./daily.webp": 96148,
	"./dark.webp": 35079,
	"./dawn.webp": 60205,
	"./dd4e344b.webp": 90185,
	"./dd87e344.webp": 73594,
	"./discofever.webp": 34527,
	"./dotty.webp": 79909,
	"./dreamworld.webp": 74694,
	"./eagle.webp": 75205,
	"./elegant-silence.webp": 89937,
	"./elisabeth.webp": 69744,
	"./epoch.webp": 24996,
	"./explosion.webp": 80962,
	"./expressionism.webp": 61116,
	"./eye.webp": 93688,
	"./fairy.webp": 90284,
	"./fantasy.webp": 26231,
	"./feast.webp": 82162,
	"./forelock.webp": 21302,
	"./forward.webp": 71676,
	"./ghibli-studio.webp": 8325,
	"./gothic.webp": 71373,
	"./grace.webp": 9297,
	"./illustration.webp": 37553,
	"./impressionism-1.webp": 25639,
	"./impressionism-2.webp": 35206,
	"./iridescent.webp": 34299,
	"./joke.webp": 46420,
	"./landscape.webp": 59076,
	"./luminous.webp": 3533,
	"./madison.webp": 15342,
	"./manga.webp": 24637,
	"./mediterranean.webp": 22918,
	"./mixture.webp": 85089,
	"./modern-art-1.webp": 34514,
	"./modern-art-2.webp": 68787,
	"./modern-art-3.webp": 43024,
	"./modern-art-4.webp": 94345,
	"./modern-art-5.webp": 55246,
	"./modern-art-6.webp": 14543,
	"./moonlight.webp": 14062,
	"./mosaic-1.webp": 62793,
	"./mosaic-2.webp": 68428,
	"./mosaic-3.webp": 25519,
	"./mudita.webp": 56837,
	"./newspaper.webp": 87290,
	"./ocean.webp": 33043,
	"./oil-painting.webp": 70468,
	"./patterns.webp": 12076,
	"./pencil.webp": 84538,
	"./petals.webp": 7906,
	"./photography.webp": 20938,
	"./pixel-art.webp": 58641,
	"./pointillism-1.webp": 39295,
	"./pointillism-2.webp": 42142,
	"./pointillism-3.webp": 3033,
	"./pop-art.webp": 9222,
	"./pop.webp": 79110,
	"./poppy.webp": 26441,
	"./promenade.webp": 42222,
	"./retro.webp": 58365,
	"./satisfaction.webp": 60831,
	"./sixties.webp": 12258,
	"./sketch-1.webp": 11425,
	"./sketch-2.webp": 76900,
	"./sketch-3.webp": 40935,
	"./sketchy.webp": 41798,
	"./snow.webp": 60540,
	"./summer.webp": 92930,
	"./sunny.webp": 96850,
	"./surrealism-1.webp": 40652,
	"./surrealism-2.webp": 61321,
	"./surrealism-3.webp": 38574,
	"./tears.webp": 69572,
	"./ukiyo-e.webp": 34859,
	"./urban.webp": 7289,
	"./voyage.webp": 95346,
	"./waterbird.webp": 24749,
	"./watercolor-1.webp": 46399,
	"./watercolor-2.webp": 57758,
	"./wolf.webp": 36127,
	"./yira.webp": 63928,
	"./zinaida.webp": 46885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47145;